import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=f956a1ee&scoped=true"
import script from "./couponList.vue?vue&type=script&lang=ts"
export * from "./couponList.vue?vue&type=script&lang=ts"
import style0 from "./couponList.vue?vue&type=style&index=0&id=f956a1ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f956a1ee",
  null
  
)

export default component.exports